/**
 * Renders a comment body string into React nodes with @-tokens turned
 * into chips. Pure projection — no state.
 */

import {
  parseCommentBody,
  formatDueDate,
  type CommentBody,
  type MemberRef,
} from '../../shared/comment-body';

export function CommentRender({ body, members }: { body: string; members: MemberRef[] }) {
  const nodes = parseCommentBody(body, members);
  return <RenderNodes nodes={nodes} />;
}

export function RenderNodes({ nodes }: { nodes: CommentBody }) {
  return (
    <>
      {nodes.map((n, i) => {
        if (n.type === 'text') {
          // Preserve newlines.
          const parts = n.text.split('\n');
          return parts.map((line, j) => (
            <span key={`t-${i}-${j}`}>
              {line}
              {j < parts.length - 1 && <br />}
            </span>
          ));
        }
        if (n.type === 'mention') {
          return (
            <span key={`m-${i}`} className="mention-chip" data-mention-user-id={n.userId}>
              @{n.name}
            </span>
          );
        }
        if (n.type === 'date') {
          return (
            <span key={`d-${i}`} className="date-chip" title={n.iso}>
              @{formatDueDate(n.iso)}
            </span>
          );
        }
        if (n.type === 'time') {
          return (
            <span key={`tm-${i}`} className="date-chip" title={`${n.minutes} min`}>
              @{n.display}
            </span>
          );
        }
        return null;
      })}
    </>
  );
}
